import { render, staticRenderFns } from "./buttom-chart.vue?vue&type=template&id=85071a74&scoped=true&"
import script from "./buttom-chart.vue?vue&type=script&lang=js&"
export * from "./buttom-chart.vue?vue&type=script&lang=js&"
import style0 from "./buttom-chart.vue?vue&type=style&index=0&id=85071a74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85071a74",
  null
  
)

export default component.exports